package com.milta.core.localization.translations.it

import com.milta.core.localization.AdminOcrAnalysisStrings

internal val AdminOcrAnalysis = AdminOcrAnalysisStrings(
    loading = "Caricamento…",
    errorNoConnection = "Impossibile contattare il server — controlla la tua connessione.",
    errorGeneric = "Si è verificato un errore. Riprova più tardi.",
    emptyStateMessage = "Nessun dato per ora.",
    kpiTotalDocumentsLabel = "Documenti analizzati",
    kpiCompletedDocumentsLabel = "Documenti completi",
    kpiCompletedDocumentsSubtitle = "simulati sulle 4 strategie",
    kpiTotalRealCostLabel = "Costo reale totale",
    kpiTotalInputTokensLabel = "Token in ingresso",
    kpiTotalOutputTokensLabel = "Token in uscita",
    breakdownByFileKindLabel = "Ripartizione",
    fileKindImageLabel = "Immagini",
    fileKindPdfLabel = "PDF",
    fileKindXlsxLabel = "Fogli di calcolo",
    flowTitle = "Il flusso completo, passo dopo passo",
    flowYesLabel = "Sì",
    flowNoLabel = "No",
    flowStep1Title = "Documento inviato",
    flowStep1Subtitle = "Foto, PDF o file ricevuto tramite l'app",
    flowStep2Title = "Impronta unica calcolata",
    flowStep2Subtitle = "Viene calcolato un identificativo unico per questo documento",
    flowStep2Note = "Se già visto: l'analisi locale non viene rifatta (il costo reale dell'IA viene comunque conteggiato normalmente, trattandosi di un invio reale).",
    flowStep3Title = "Tipo di file rilevato",
    flowStep3Subtitle = "Il resto dell'analisi differisce a seconda del tipo",
    flowImageBranchTitle = "📷 Se è una foto",
    flowImageStep1Title = "Controllo qualità",
    flowImageStep1Subtitle = "Nitidezza, luminosità, risoluzione, documento ben inquadrato",
    flowImageStep2Title = "Se la qualità è giudicata insufficiente",
    flowImageStep2Subtitle = "Il motivo viene registrato, ma la lettura locale viene comunque tentata subito dopo",
    flowImageStep3Title = "Correzione dell'inclinazione",
    flowImageStep3Subtitle = "L'immagine viene raddrizzata se viene rilevata un'inclinazione affidabile",
    flowImageStep4Title = "Lettura locale (gratuita)",
    flowImageStep4Subtitle = "Lettura del testo senza IA — francese, olandese, inglese",
    flowImageStep5Title = "Punteggio di affidabilità",
    flowImageStep5Subtitle = "Punteggio da 0 a 100 sulla qualità di questa lettura locale",
    flowPdfBranchTitle = "📄 Se è un PDF",
    flowPdfStep1Title = "Testo nativo rilevato?",
    flowPdfStep1Subtitle = "Verifica se il PDF contiene già testo digitale utilizzabile",
    flowPdfNote = "Se scansionato senza testo nativo: ogni pagina (max 20) viene renderizzata come immagine e riletta localmente, come una foto.",
    flowXlsxBranchTitle = "📊 Se è un foglio di calcolo",
    flowXlsxStep1Title = "Colonne identificate",
    flowXlsxStep1Subtitle = "Riconoscimento automatico, o assistito dall'IA, delle colonne (nome, indirizzo, telefono…)",
    flowXlsxNote = "Struttura del file (righe, colonne, intestazione) analizzata localmente.",
    flowClaudeTitle = "Chiamata all'IA (Claude)",
    flowClaudeSubtitle = "Oggi viene sempre effettuata una chiamata reale, indipendentemente dal percorso sopra — costo reale addebitato",
    flowSimulationTitle = "🔬 Simulazione a posteriori (non in produzione)",
    flowSimulationNote = "Una volta raccolti i dati sopra, 4 strategie alternative vengono rieseguite sugli stessi documenti per stimare quanto sarebbero costate al posto della chiamata sistematica all'IA — è esattamente ciò che confronta la tabella sottostante. Nessuna di queste 4 strategie è effettivamente usata in produzione oggi.",
    flowPersistTitle = "Salvato",
    flowPersistSubtitle = "Il risultato reale e le 4 simulazioni vengono memorizzati",
    flowDashboardTitle = "Dashboard",
    flowDashboardSubtitle = "Questa schermata aggrega i risultati per strategia",
    tableTitle = "Confronto delle strategie possibili",
    columnMode = "Strategia",
    columnDocuments = "Documenti",
    columnClaudeCalls = "Chiamate all'IA",
    columnProjectedCost = "Costo previsto",
    columnRealCost = "Costo reale",
    columnSavings = "Risparmio previsto",
    modeBaseline = "Strategia attuale",
    modeBaselineDescription = "L'IA viene chiamata sistematicamente per ogni documento — questo è ciò che viene realmente usato oggi in produzione.",
    modeMinimal = "Pre-elaborazione leggera",
    modeMinimalDescription = "Piccole ottimizzazioni prima dell'invio all'IA, senza cambiare la decisione: l'IA viene sempre chiamata, stesso costo della strategia attuale.",
    modeTesseractGate = "Lettura locale con ricorso all'IA",
    modeTesseractGateDescription = "Una lettura locale gratuita valuta prima la qualità del documento; l'IA viene chiamata solo se questa lettura è giudicata insufficiente.",
    modeTesseractOnly = "Solo lettura locale",
    modeTesseractOnlyDescription = "Nessuna chiamata all'IA — solo una lettura locale gratuita, potenzialmente meno affidabile su documenti di scarsa qualità.",
)
